"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class IpApp {
    /**
     * @method openWithParams: Function to return schema supported to open an IpApp
     * and send queryParameters
     * @param appId Id of the app has to match AppInfo AppId, Please refer to 706 Broswer Spec
     * @options Object that will set the query parameters when openning an IpApp
     * @Return Custom Schema to set an itention on browser to launch IpApp
     */
    static openWithParams(appId, options) {
        try {
            if (Object.keys(options).length === 0) {
                throw Error('Must specify query parameters to use this fuction');
            }
            const queryParams = Object.keys(options).map((value) => {
                return `${value}=${options[value]}`;
            });
            return `com.toyota.app://?app_id=${appId}${queryParams.join('&')}`;
        }
        catch (e) {
            throw Error(e);
        }
    }
    /**
     * @method openWithParams: Function to return schema supported to open an IpApp without options
     * @param appId Id of the app has to match AppInfo AppId, Please refer to 706 Broswer Spec
     * @Return Custom Schema to set an itention on browser to launch IpApp
     */
    static open(appId) {
        try {
            if (appId === '') {
                throw Error('Must specify AppId to use this function');
            }
            return `com.toyota.app://?app_id=${appId}`;
        }
        catch (e) {
            throw Error(e);
        }
    }
    /**
     * @method close: Function to close current IpApp
     * @param animation: If when closing IpApp need to execute an Animation,
     * possible values OpeningAnimation or ClosingAnimation
     */
    static close(animation) {
        try {
            if (animation) {
                ToyotaClose.quitWindow('CLOSE', animation);
            }
            else {
                ToyotaClose.quitWindow('CLOSE');
            }
        }
        catch (e) {
            throw Error(e);
        }
    }
    /**
     * @method hide: Function to hide current IpApp
     * @param animation: If when closing IpApp need to execute an Animation,
     * possible values OpeningAnimation or ClosingAnimation
     */
    static hide(animation) {
        try {
            if (animation) {
                ToyotaClose.quitWindow('HIDE', animation);
            }
            else {
                ToyotaClose.quitWindow('HIDE');
            }
        }
        catch (e) {
            throw Error(e);
        }
    }
    /**
     * @method crash: Function to close current IpApp by failure on flow or system,
     * need to specify error object
     * @param description: Description of the error or comment to be set on the platform,
     * possible values OpeningAnimation or ClosingAnimation
     */
    static crash(description) {
        try {
            ToyotaClose.quitWindow('ERROR', null, {
                code: '910',
                comment: description,
                reason: 'Fatal Error',
            });
        }
        catch (e) {
            throw Error(e);
        }
    }
}
exports.default = IpApp;
//# sourceMappingURL=IpApp.js.map